import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import type {GridFilterOperator} from '@mui/x-data-grid';
import {IntegerBetweenFilterComponent} from "./IntegerBetweenFilterComponent.tsx";

/**
 * General-purpose "between" filter for integer columns, e.g. p_year. Unlike scoreBetweenFilter
 * (ScoreBetweenFilter.tsx, hardcoded 0..100 for the suggestion_score field) this has no
 * pre-configured range: 0 and negative values are valid, and there is no upper bound.
 */
export const integerBetweenFilter: GridFilterOperator<PartGridRowModel, number> =
    {
        headerLabel: 'Between',
        label: 'Between',
        value: 'between',
        getApplyFilterFn: (filterItem) => {
            if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
                return null;
            }
            const [lowerRaw, upperRaw] = filterItem.value;
            if (lowerRaw == null || upperRaw == null) {
                return null;
            }
            const lower = Number(lowerRaw);
            const upper = Number(upperRaw);
            if (Number.isNaN(lower) || Number.isNaN(upper)) {
                return null;
            }
            return (value) => {
                return (
                    value !== null &&
                    lower <= value &&
                    value <= upper
                );
            };
        },
        InputComponent: IntegerBetweenFilterComponent,
    };
